import { useQuery } from 'react-query';
import { getFlexDisconnectReasons } from 'RestAPIs/flex-disconnect-reasons';

const useGetFlexDisconnectReasons = () => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['flexDisconnectReason', 'list'],
    async () => {
      const { data } = await getFlexDisconnectReasons();
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetFlexDisconnectReasons;
